<div class="publish-to-valorem">
  <div class="valorem-publish-header">
    <svg-icon src='./assets/icons/close-outline.svg'
              class="svg-icon-large valorem-close-icon" (click)="cancel()" title="{{ 'raci.publishToValorem.close' | translate | uppercase }}"></svg-icon>
  </div>
  <div class="content-title">
    {{ 'raci.closeValuationEvent.title' | translate}}
  </div>
  <div class="valorem-content">
    <div class="content-body">

      <p>{{ dialogMessage | translate }}</p>
      <p>{{ 'raci.closeValuationEvent.continueOption' | translate}}</p>
    </div>
    <div class="footer-wraper">
        <button kendoButton class="footer-button" (click)="cancel()">{{'raci.closeValuationEvent.cancel' | translate}}</button>
        <button kendoButton class="footer-button" (click)="continue()">{{'raci.closeValuationEvent.continue' | translate}}</button>
    </div>
  </div>
</div>
